import styled from 'styled-components';

export const AboutPageWrapper = styled.div``;

export const AboutContent = styled.div<{
  background?: 'transparent' | 'white' | 'primary' | null;
}>`
  background-color: ${(props) => props.background || 'transparent'};
  padding: 0 16px;
  padding-bottom: 64px;
`;
